import {grey} from "@mui/material/colors";

export function RowNumberIndicator(props: {
    value: number;
}) {
    return (
        <div style={{
            paddingRight: 4,
            color: grey["600"]
        }}>{props.value}</div>
    )
}